"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deltaTowardsXY = exports.rotateTurns = exports.rotate = exports.fromTurns = exports.fromAngle = exports.scale = exports.create = exports.normalizeSafe = exports.normalizeSafe2 = exports.length = exports.length2 = void 0;
function length2(x, y) {
    return Math.sqrt(x * x + y * y);
}
exports.length2 = length2;
function length(v) {
    return Math.sqrt(v.x * v.x + v.y * v.y);
}
exports.length = length;
function normalizeSafe2(x, y) {
    var l = length2(x, y);
    if (l <= 0.001) {
        return { x: 1, y: 0 };
    }
    return { x: x / l, y: y / l };
}
exports.normalizeSafe2 = normalizeSafe2;
function normalizeSafe(v) {
    var l = length(v);
    if (l <= 0.001) {
        return { x: 1, y: 0 };
    }
    return { x: v.x / l, y: v.y / l };
}
exports.normalizeSafe = normalizeSafe;
function create(x, y) {
    return { x: x, y: y };
}
exports.create = create;
function scale(v, s) {
    return { x: v.x * s, y: v.y * s };
}
exports.scale = scale;
function fromAngle(angle, length) {
    return create(Math.cos(angle) * length, Math.sin(angle) * length);
}
exports.fromAngle = fromAngle;
function fromTurns(turns, length) {
    return fromAngle(turns * Math.PI * 2, length);
}
exports.fromTurns = fromTurns;
function rotate(v, angle) {
    var c = Math.cos(angle);
    var s = Math.sin(angle);
    return create(v.x * c - v.y * s, v.x * s + v.y * c);
}
exports.rotate = rotate;
function rotateTurns(v, turns) {
    return rotate(v, turns * Math.PI * 2);
}
exports.rotateTurns = rotateTurns;
// export function moveTowardsXY(obj: IXY, target: IXY, max: number) {
//   let dx = target.x - obj.x
//   let dy = target.y - obj.y
//   let v = create(dx, dy)
//   let len = length(v)
//   if (len < max) {
//     return create(target.x, target.y)
//   }
//   v = normalizeSafe(v)
//   v = scale(v, max)
//   return v
// }
function deltaTowardsXY(obj, target, max) {
    var dx = target.x - obj.x;
    var dy = target.y - obj.y;
    var v = create(dx, dy);
    var len = length(v);
    if (len < max) {
        return create(dx, dy);
    }
    v = normalizeSafe(v);
    v = scale(v, max);
    return v;
}
exports.deltaTowardsXY = deltaTowardsXY;
